import { TermDto } from '@act/shared/data-transfer-objects';
import { Box, Typography } from '@mui/material';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { Link, useNavigate } from 'react-router-dom';

interface ConsentTermHeaderProps {
  term: TermDto;
}

const ConsentTermHeader = ({ term }: ConsentTermHeaderProps) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexShrink: 0,
        width: '100%',
        padding: '8px 0',
      }}
    >
      <Link
        to={'..'}
        onClick={e => {
          e.preventDefault();
          navigate(-1);
        }}
        style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
        }}
      >
        <CaretLeftIcon
          color="#021e38"
          size={32}
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        />
      </Link>
      <Typography
        variant="titleLarge"
        sx={{
          color: '#021e38',
          display: 'flex',
          alignItems: 'center',
          lineHeight: 1,
        }}
      >
        {term?.name}
      </Typography>
    </Box>
  );
};

export default ConsentTermHeader;
